import axios from 'axios'

export const all = (): Promise<any> => {
  return axios.get('user-logs')
}

export const getUser = (userId: number): Promise<any> => {
  return axios.get('user-logs/user/' + userId)
}
